import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { jFileLittle } from 'jamespot-user-api';
import { Widget } from 'jamespot-front-business';
import styled from 'styled-components';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppSelector } from '../../../redux/store';

const JRCInputFileAdvancedRaw = commonComponentsRegistry.getLazyComponent('InputFileAdvancedRaw');

export const CSSHidden = styled.div`
    width: 0;
    height: 0;
    overflow: hidden;
`;

type InplaceUploaderProps = {
    children: ReactNode;
    initialFiles: jFileLittle[];
    initialClick?: boolean;
    multiple: boolean;
    accept: string;
    onUploadStart: () => void;
    onUploadEnd: () => void;
    onUploadSuccess: (files: jFileLittle[]) => void;
};

export const WidgetUploader = ({
    children,
    initialFiles,
    initialClick,
    multiple,
    accept,
    onUploadStart,
    onUploadEnd,
    onUploadSuccess,
}: InplaceUploaderProps) => {
    const uploadRef = useRef<HTMLInputElement>(null);
    const token = useAppSelector(Widget.selectors.selectToken);
    const [total, setTotal] = useState<number>(0);
    const [files, setFiles] = useState<jFileLittle[]>(initialFiles);

    useEffect(() => {
        if (initialClick) {
            uploadRef.current?.click();
        }
    }, [initialClick]);

    useEffect(() => {
        if (initialFiles.length !== files.length) {
            setFiles(initialFiles);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialFiles]);

    useEffect(() => {
        onUploadSuccess(files);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files]);

    useEffect(() => {
        if (total === 0) {
            onUploadEnd();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [total]);

    return (
        <>
            <div
                onClick={() => {
                    if (initialClick) {
                        uploadRef.current?.click();
                    }
                }}>
                {children}
            </div>
            <CSSHidden>
                <JRCInputFileAdvancedRaw
                    ref={uploadRef}
                    id="widget-upload-file"
                    name="editorFiles"
                    content={''}
                    accept={accept as any}
                    multiple={multiple}
                    token={token}
                    onUploadStart={(totalFile) => {
                        if (totalFile !== undefined) {
                            setTotal((prevTotal) => prevTotal + totalFile);
                        }
                        if (typeof onUploadStart === 'function' && totalFile !== 0) {
                            onUploadStart();
                        }
                    }}
                    onUploadSuccess={(fileResponse) => {
                        if (fileResponse === undefined) {
                            return;
                        }
                        setTotal((prevTotal) => (prevTotal !== undefined ? prevTotal - 1 : 0));
                        setFiles((prevFiles) => (multiple ? [...prevFiles, fileResponse] : [fileResponse]));
                    }}
                />
            </CSSHidden>
        </>
    );
};
